<script lang="ts">
  import { t } from '../../i18n/index.svelte';
  import { NAMED_PALETTES } from '../../types';

  let { colors = $bindable() }: { colors: string[] } = $props();
</script>

<div class="palette">
  <span class="label row head">
    {t('texture.palette')}
    <select
      class="named"
      onchange={(e) => {
        const v = (e.currentTarget as HTMLSelectElement).value;
        if (v) colors = [...NAMED_PALETTES[v]];
        (e.currentTarget as HTMLSelectElement).value = '';
      }}
      data-testid="palette-preset"
    >
      <option value="">{t('texture.palettePreset')}</option>
      {#each Object.keys(NAMED_PALETTES) as k (k)}<option value={k}>{t(`palette.${k}` as never)}</option>{/each}
    </select>
  </span>
  <div class="swatches">
    {#each colors as _, i (i)}
      <span class="swatch">
        <input type="color" bind:value={colors[i]} aria-label={`${t('texture.color')} ${i + 1}`} />
        {#if colors.length > 1}
          <button class="x" title={t('common.remove')} onclick={() => (colors = colors.filter((_, j) => j !== i))}
            >×</button
          >
        {/if}
      </span>
    {/each}
    {#if colors.length < 8}
      <button
        class="add"
        title={t('common.add')}
        onclick={() => (colors = [...colors, colors[colors.length - 1] ?? '#808080'])}>+</button
      >
    {/if}
  </div>
</div>

<style>
  .palette {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 13px;
  }
  .head {
    justify-content: space-between;
  }
  .named {
    width: auto;
    padding: 1px 4px;
    font-size: 12px;
  }
  .swatches {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .swatch {
    position: relative;
  }
  input[type='color'] {
    width: 34px;
    height: 28px;
    padding: 0;
    border: 1px solid var(--line);
    border-radius: 6px;
    background: none;
    cursor: pointer;
  }
  .x {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 16px;
    height: 16px;
    padding: 0;
    line-height: 12px;
    font-size: 12px;
    border-radius: 50%;
    display: none;
  }
  .swatch:hover .x {
    display: block;
  }
  .add {
    width: 34px;
    height: 28px;
    padding: 0;
  }
</style>
